<template>
    <career-youth-programs-template-page :show-filter="true" :isLinkCards="true"/>
</template>

<script setup>
    import CareerYouthProgramsTemplatePage from './template/CareerYouthProgramsTemplatePage.vue'
</script>